document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.suko-testimonials').forEach(function (wrap) {
    var track = wrap.querySelector('.suko-testimonials__track');
    var prev = wrap.querySelector('[data-suko-prev]');
    var next = wrap.querySelector('[data-suko-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.suko-testimonial-card');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  // Pause other open accordion items within the same accordion for a tidier look (optional, non-exclusive by default).
});
